import { render, staticRenderFns } from "./WikiDataSheetTabTable.vue?vue&type=template&id=5ced0f72&scoped=true"
import script from "./WikiDataSheetTabTable.vue?vue&type=script&lang=ts"
export * from "./WikiDataSheetTabTable.vue?vue&type=script&lang=ts"
import style0 from "./WikiDataSheetTabTable.vue?vue&type=style&index=0&id=5ced0f72&prod&lang=css"
import style1 from "./WikiDataSheetTabTable.vue?vue&type=style&index=1&id=5ced0f72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ced0f72",
  null
  
)

export default component.exports